import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { filter } from 'jszip';
import { ConfirmationService, MessageService, TreeNode } from 'primeng/api';
import { TreeTable } from 'primeng/treetable';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ROLE_HIERARCHY } from '../constant/users-module-name';
import { AssociatedUser } from '../user/models/associated-user.model';
import { AddUpdateRoleHierarchy } from './models/add-update-role.model';
import { RoleHierarchy } from './models/role-hierarchy.model';
import { RoleHierarchyService } from './services/role-hierarchy.service';
import { ConfigurationService } from '../../configurationService';

@Component({
    selector: "app-role-hierarchy",
    templateUrl: "./role-hierarchy.component.html",
    styleUrls: ["./role-hierarchy.component.scss"],
})
export class RoleHierarchyComponent implements OnInit, OnDestroy {
    rolesAll: TreeNode[];
    displayAddEditRole = false;
    roleHeader;
    rolesDD: any[];
    selectedNode;
    tempRole = {
        data: {
            name: "",
            data: "",
            createdBy: this.app.user.userId,
            updatedDate: new Date(),
        },
        children: [],
    };
    disableNode = false;
    configMenuRoleItems;

    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>();

    hierarchyRoles: TreeNode[];
    hierarchyRolesVM: TreeNode[];
    hierarchyRolesVM2: TreeNode[];
    reportedToList: RoleHierarchy[] = [];
    reportedToListVM: RoleHierarchy[] = [];

    roleHierarchyForm: FormGroup;
    displayAssociatedUsersModal: boolean = false;
    associatedUsers: AssociatedUser[] = [];
    displayTransferRoleModal: boolean = false;
    roleForTransfer: any;

    roleTransferForm: FormGroup;
    readonly subModuleName: string = ROLE_HIERARCHY;
    roleHierarchyIdForSelectedAssociatedUser: number;
    selectedRoleHierarchyName: string;
    companyName: string;

    @ViewChild("roleTreeTable") roleTreeTable: TreeTable;

    constructor(
        public app: AppMainComponent,
        private appMainService: AppMainService,
        private roleHierarchyService: RoleHierarchyService,
        private messageService: MessageService,
        private formBuilder: FormBuilder,
        private confirmationService: ConfirmationService,
        private configurationService: ConfigurationService,
    ) {
        this.prepareRoleHierarchyForm();
        this.prepareRoleTransferForm();
    }

    ngOnInit(): void {
        this.companyName = this.app.organizationData.name;
        this.getRoleHierarchyList();
        this.configMenuRoleItems = [
            {
                label: "Role Hierarchy",
                icon: "pi pi-plus",
                command: () => {
                    this.addNewRole();
                },
            },
        ];
    }

    getRoleHierarchyList(msg?): void {
        this.appMainService.isShowSpinner("getRoleHierarchyList");
        this.roleHierarchyService
            .getAllRoleHierarchy()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    // const addCompany = {
                    //     label: "ACV",
                    //     children: convertedData
                    // }
                    const data = response;
                    const convertedData = this.convertJsonForTreeSelect(data);

                    let reportParent: any = [{
                       id: 0,
                       label: this.companyName,
                        children: JSON.parse(
                            JSON.stringify(convertedData)
                          )
                    }];
                    this.reportedToList = reportParent;

                    this.reportedToListVM = JSON.parse(
                        JSON.stringify(convertedData)
                    );
                    //this.hierarchyRoles = this.convertRoleHierarchyDataToPrimeNgTreeNodeModel(response);
                    const convertedRoleHiearchyData = this.convertRoleHierarchyDataToPrimeNgTreeNodeModel(response);
                    let addCompany = [{
                        data: {
                            id: 0,
                            roleName: this.companyName,
                            noOfAssociatedUsers: null
                        },
                        children: convertedRoleHiearchyData
                    }];
                    this.hierarchyRoles = addCompany;
                    this.hierarchyRolesVM = JSON.parse(
                        JSON.stringify(this.hierarchyRoles)
                    );
                    this.hierarchyRolesVM2 = this.hierarchyRoles;
                    //console.log(this.reportedToList);
                    //console.log(this.hierarchyRoles);
                    if(msg == 'expand'){
                        this.expandAllRoles()
                    }
                    this.appMainService.isHideSpinner("getRoleHierarchyList");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("getRoleHierarchyList");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: error?.error?.Message
                            ? error?.error?.Message
                            : "Role lists are not loaded, please try again later..",
                    });
                },
                complete: () => {},
            });
    }

    convertJsonForTreeSelect(inputJson) {
        return inputJson.map((item) => ({
            ...item,
            label: item.roleName,
            children: this.convertJsonForTreeSelect(item.childRoleDTO),
        }));
    }

    convertRoleHierarchyDataToPrimeNgTreeNodeModel(
        originalData: RoleHierarchy[]
    ) {
        const convertedData = originalData.map((item) => {
            const { childRoleDTO, ...data } = item;
            const children =
                this.convertRoleHierarchyDataToPrimeNgTreeNodeModel(
                    childRoleDTO
                );
            return {
                data,
                children,
            };
        });
        return convertedData;
    }

    expandAllRoles(): void {
        this.expandAndCollapseRecursive(this.hierarchyRolesVM, true);
        this.hierarchyRoles = [];
        this.hierarchyRoles = JSON.parse(JSON.stringify(this.hierarchyRolesVM));
    }

    collapseAllRoles(): void {
        this.expandAndCollapseRecursive(this.hierarchyRolesVM, false);
        this.hierarchyRoles = [];
        this.hierarchyRoles = JSON.parse(JSON.stringify(this.hierarchyRolesVM));
    }

    expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (node.children) {
            node.children.forEach((childNode) => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }

    removeCircularReferences(obj) {
        if (typeof obj === "object" && obj !== null) {
            obj.parent = null; // remove parent property
            if (Array.isArray(obj)) {
                obj.forEach(this.removeCircularReferences); // remove circular references from array elements
            } else {
                Object.values(obj).forEach(this.removeCircularReferences); // remove circular references from object values
            }
        }
    }

    expandAndCollapseRecursive(nodes: TreeNode[], isExpand: boolean) {
        nodes.forEach((node) => {
            node.expanded = isExpand;
            if (node.children.length > 0) {
                this.expandAndCollapseRecursive(node.children, isExpand);
            }
        });
    }

    prepareRoleHierarchyForm(): void {
        this.roleHierarchyForm = this.formBuilder.group({
            roleId: [0],
            roleName: ["", Validators.required],
            parentId: ["", Validators.required],
            level: [0],
        });
    }

    // Required field validation

    get roleName() {
        return this.roleHierarchyForm.get("roleName");
    }
    get parentId() {
        return this.roleHierarchyForm.get("parentId");
    }
    get role() {
        return this.roleTransferForm.get("role");
    }

    addNewRole(data?): void {
        this.roleHeader = "New Role";

        if (!data) {
            this.disableNode = true;
            this.roleHierarchyForm.patchValue({
                parentId: null,
                level: 0,
            });
            this.reportedToList = [];
            this.reportedToList = JSON.parse(
                JSON.stringify(this.reportedToListVM)
            );
            this.parentId.clearValidators();
            this.parentId.updateValueAndValidity();
        } else {
            this.roleHierarchyForm.patchValue({ roleName: "" });
            for (let s of this.reportedToList) {
                this.selectedNode = this.searchInTree(s, data.id);
                if (this.selectedNode != null) {
                    break;
                }
            }
            this.disableNode = false;
        }
        this.displayAddEditRole = true;
    }

    searchInTree(element, id): void {
        if (element.id == id) {
            return element;
        } else if (element.children != null) {
            var i;
            var result = null;
            for (i = 0; result == null && i < element.children.length; i++) {
                result = this.searchInTree(element.children[i], id);
            }
            return result;
        }
        return null;
    }

    editRole(editData, rowNode): void {
        this.roleHeader = "Edit Role";
        this.setEditRoleHierarchyForm(editData, rowNode);

        if (rowNode.parent !== null) {
            this.disableNode = false;
            for (let s of this.reportedToList) {
                this.selectedNode = this.searchInTree(
                    s,
                    rowNode.parent.data.id
                );
                if (this.selectedNode != null) {
                    break;
                }
            }
        } else {
            this.disableNode = true;
        }
        this.displayAddEditRole = true;
    }

    setEditRoleHierarchyForm(editData, rowNode): void {
        this.roleHierarchyForm = this.formBuilder.group({
            roleId: [editData?.id],
            roleName: [editData?.roleName, Validators.required],
            parentId: [
                this.disableNode ? 0 : rowNode?.node?.data,
                Validators.required,
            ],
            level: [editData?.level],
        });
    }

    saveRoleHierarchy(): void {
        if (this.roleHierarchyForm.valid) {
            const roleHierarchyData: AddUpdateRoleHierarchy = {
                roleId: this.roleHierarchyForm.value["roleId"],
                roleName: this.roleHierarchyForm.value["roleName"],
                parentId: this.disableNode
                    ? null
                    : this.roleHierarchyForm.value["parentId"]?.id,
                level: this.roleHierarchyForm.value["level"]
                    ? this.roleHierarchyForm.value["level"]
                    : this.roleHierarchyForm.value["parentId"]?.level,
            };
            this.appMainService.isShowSpinner("saveRoleHierarchy");
            this.roleHierarchyService
                .addRoleHierarchy(roleHierarchyData)
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe({
                    next: (response) => {
                        this.getRoleHierarchyList('expand');
                        this.roleHierarchyForm.reset();
                        this.displayAddEditRole = false;
                        let addUpdateText: string = "";
                        this.roleHeader == "New Role"
                            ? (addUpdateText = "added")
                            : (addUpdateText = "updated");
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: `Role hierarchy ${addUpdateText} successfully...`,
                        });
                        this.appMainService.isHideSpinner("saveRoleHierarchy");
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner("saveRoleHierarchy");
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error?.error?.Message
                                ? error?.error?.Message
                                : "Error occured, please try again later..",
                        });
                    },
                    complete: () => {},
                });
        }
    }

    cancelRoleHierarchy() {
        this.displayAddEditRole = false;
        this.selectedNode = null;
        this.disableNode = false;
        this.roleHierarchyForm.reset();
    }

    searchTree(element, matchingTitle) {
        if (element.data == matchingTitle) {
            return element;
        } else if (element.children != null) {
            var i;
            var result = null;
            for (i = 0; result == null && i < element.children.length; i++) {
                result = this.searchTree(element.children[i], matchingTitle);
            }
            return result;
        }
        return null;
    }

    getNoOfAssociatedUsers(roleId: any, roleName, isAddedNewUser = false): void {
      this.roleHierarchyIdForSelectedAssociatedUser = roleId;
      this.selectedRoleHierarchyName = roleName;
        this.appMainService.isShowSpinner("getNoOfAssociatedUsers");
        this.roleHierarchyService
            .getAssociatedUsers(this.roleHierarchyIdForSelectedAssociatedUser)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.associatedUsers = response;
                    this.displayAssociatedUsersModal = true;
                    if (isAddedNewUser){
                      this.getRoleHierarchyList();
                    }
                    this.appMainService.isHideSpinner("getNoOfAssociatedUsers");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("getNoOfAssociatedUsers");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: error?.error?.Message
                            ? error?.error?.Message
                            : "User lists are not loaded, please try again later..",
                    });
                },
                complete: () => {},
            });
    }

    closeAssociatedUserModalOutputEvent(): void {
        this.displayAssociatedUsersModal = false;
        this.associatedUsers = [];
    }

    completedAddNewUser(): void {
      this.getNoOfAssociatedUsers(this.roleHierarchyIdForSelectedAssociatedUser, this.selectedRoleHierarchyName, true);
    }

    closeTransferRoleModal(): void {
        this.roleTransferForm.reset();
        this.displayTransferRoleModal = false;
    }

    deleteRoleHierarchy(data): void {
        this.confirmationService.confirm({
            message: "Do you want to delete this role?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.roleForTransfer = data;
                this.checkNodeChildAssociatedUsers(data);
            },
            reject: () => {},
        });
    }

    checkNodeChildAssociatedUsers(data): void {
        this.appMainService.isShowSpinner("checkNodeChildAssociatedUsers");
        let result: boolean;
        this.roleHierarchyService
            .checkNodeChildAssociatedUsers(data?.id)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response: boolean) => {
                    result = response;
                    if (result) {
                        this.displayTransferRoleModal = true;
                        const reportedToList = JSON.parse(JSON.stringify(this.reportedToListVM));
                        const filteredRoles = this.removeRolesById(reportedToList, data?.id);
                        this.reportedToList = [];
                        this.reportedToList = filteredRoles;
                        //console.log(this.reportedToList);
                    } else {
                        this.deleteRole(data?.id);
                    }
                    this.appMainService.isHideSpinner(
                        "checkNodeChildAssociatedUsers"
                    );
                },
                error: (error) => {
                    this.appMainService.isHideSpinner(
                        "checkNodeChildAssociatedUsers"
                    );
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: error?.error?.Message
                            ? error?.error?.Message
                            : "Error occured, please try again later..",
                    });
                },
                complete: () => {},
            });
    }

    removeRolesByRoleName(roles, roleName) {
        let updatedRoles = [];
        for (let i = 0; i < roles.length; i++) {
            const role = roles[i];
            if (!role.roleName.toLowerCase().includes(roleName.toLowerCase())) {
                let updatedRole = Object.assign({}, role);
                if (role.children && role.children.length > 0) {
                    updatedRole.children = this.removeRolesByRoleName(
                        role.children,
                        roleName
                    );
                }
                updatedRoles.push(updatedRole);
            }
        }
        return updatedRoles;
    }

    removeRolesById(roles, id) {
      for (let i = 0; i < roles.length; i++) {
          const role = roles[i];
          if (role.id === id) {
              roles.splice(i, 1);
              i--;
          } else if (role.children && role.children.length > 0) {
              const childResult = this.removeRolesById(role.children, id);
              role.children = childResult;
            //   if (childResult.length === 0) {
            //       roles.splice(i, 1);
            //       i--;
            //   }
          }
      }
      return roles;
    }

    deleteRole(roleHierarchyId: number): void {
        this.appMainService.isShowSpinner("deleteRole");
        this.roleHierarchyService
            .deleteRole(roleHierarchyId)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.getRoleHierarchyList('expand');
                    this.appMainService.isHideSpinner("deleteRole");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("deleteRole");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: error?.error?.Message
                            ? error?.error?.Message
                            : "Error occured, please try again later..",
                    });
                },
                complete: () => {},
            });
    }

    prepareRoleTransferForm(): void {
        this.roleTransferForm = this.formBuilder.group({
            role: ["", Validators.required],
        });
    }

    transferAndDeleteRole(): void {
        const roleTransferData = {
            idforDelete: this.roleForTransfer?.id,
            idforTransfer: this.roleTransferForm.value["role"]?.id,
            targetrolelevel: this.roleTransferForm.value["role"]?.level,
        };
        this.appMainService.isShowSpinner("transferAndDeleteRole");
        this.roleHierarchyService
            .transferRole(roleTransferData)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.displayTransferRoleModal = false;
                    this.roleForTransfer = null;
                    this.getRoleHierarchyList('expand');
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: "Transfer and deleted successfully...",
                    });
                    this.appMainService.isHideSpinner("transferAndDeleteRole");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("transferAndDeleteRole");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: error?.error?.Message
                            ? error?.error?.Message
                            : "Error occurred while transfer and delete role...",
                    });
                },
                complete: () => {},
            });
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
